import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M18 2.4A3.6 3.6 0 0 1 21.6 6v12a3.6 3.6 0 0 1-3.6 3.6H6A3.6 3.6 0 0 1 2.4 18V6A3.6 3.6 0 0 1 6 2.4h12Z"
      fill="none"
    />
    <path
      stroke="currentColor"
      strokeWidth="2"
      d="M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
      fill="none"
    />
    <circle cx="18" cy="7" r="1" fill="currentColor" />
  </>,
  'Instagram'
)
